import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { reportScreen } from '../../services/analyticsService';
import OffersPage from '../../containers/OffersPage';
import ContentHeader from '../../components/ContentHeader';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { fetchPendingActions } from '../../reducers/Offer/actions';
import { Page } from '../../components/layout';

import './index.scss';

export default () => {
  const dispatch = useDispatch();
  useDocumentTitle('Dashboard');
  useEffect(() => {
    reportScreen('dashboard');
  }, []);

  useEffect(() => {
    dispatch(fetchPendingActions());
  }, []);

  return (
    <Page>
      <ContentHeader title="Dashboard" />
      <OffersPage />
    </Page>
  );
};
